var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableHow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 280,
    viewBox: "0 0 294 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_848_194)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.886 66.3823C176.486 66.3823 192.572 72.1379 205.404 82.6685C218.236 93.199 227.02 107.853 230.258 124.133C233.497 140.414 230.99 157.313 223.165 171.953C215.34 186.592 202.68 198.065 187.344 204.418C172.008 210.77 154.943 211.608 139.058 206.79C123.173 201.971 109.45 191.794 100.228 177.992C91.0053 164.19 86.8539 147.618 88.481 131.098C90.108 114.579 97.4128 99.1346 109.151 87.397C115.798 80.7137 123.705 75.415 132.413 71.8078C141.122 68.2007 150.46 66.3566 159.886 66.3823ZM159.886 13.707C91.1666 13.707 35.4585 69.4135 35.4585 138.131C35.4585 206.848 91.1666 262.555 159.886 262.555C228.606 262.555 284.314 206.848 284.314 138.131C284.314 69.4135 228.606 13.707 159.886 13.707Z",
    fill: "url(#paint0_linear_848_194)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.12 248.348H154.203C153.212 248.348 152.41 249.15 152.41 250.141V278.199C152.41 279.189 153.212 279.992 154.203 279.992H168.12C169.111 279.992 169.913 279.189 169.913 278.199V250.141C169.913 249.15 169.111 248.348 168.12 248.348Z",
    fill: "#343435"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.921 250.133H153.401V278.191H168.921V250.133Z",
    fill: "#C0E3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.491 272.499H149.045V258.473H155.857L159.491 262.107V272.499Z",
    fill: "#0B121E"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.324 271.671H149.878V257.645H156.689L160.324 261.279V271.671Z",
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0038 152.367H27.4717V169.633H48.0038V152.367Z",
    fill: "#282828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3194 169.637H26.1572V171.246H49.3194V169.637Z",
    fill: "#343435"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.103 104.035H3.37334C1.5103 104.035 0 105.545 0 107.408V155.382C0 157.245 1.5103 158.756 3.37334 158.756H72.103C73.966 158.756 75.4763 157.245 75.4763 155.382V107.408C75.4763 105.545 73.966 104.035 72.103 104.035Z",
    fill: "#343435"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1031 107.207H3.37354V144.959H72.1031V107.207Z",
    fill: "#C0E3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.541 121.812H277.623C276.633 121.812 275.83 122.615 275.83 123.606V151.664C275.83 152.654 276.633 153.457 277.623 153.457H291.541C292.531 153.457 293.334 152.654 293.334 151.664V123.606C293.334 122.615 292.531 121.812 291.541 121.812Z",
    fill: "#343435"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.341 123.609H276.821V151.667H292.341V123.609Z",
    fill: "#C0E3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M282.912 145.968H272.466V131.941H279.278L282.912 135.576V145.968Z",
    fill: "#0B121E"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283.744 145.144H273.298V131.117H280.11L283.744 134.752V145.144Z",
    fill: "#F7F7F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.12 -0.0117188H154.203C153.212 -0.0117188 152.41 0.791046 152.41 1.78131V29.8394C152.41 30.8297 153.212 31.6324 154.203 31.6324H168.12C169.111 31.6324 169.913 30.8297 169.913 29.8394V1.78131C169.913 0.791046 169.111 -0.0117188 168.12 -0.0117188Z",
    fill: "#343435"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.921 1.78125H153.401V29.8393H168.921V1.78125Z",
    fill: "#C0E3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M159.492 24.1516H149.046V10.125H155.857L159.492 13.7593V24.1516Z",
    fill: "#0B121E"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.324 23.3156H149.878V9.28906H156.689L160.324 12.9234V23.3156Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M167.879 149.436H150.784V126.969H164.723L167.879 130.124V149.436Z",
    fill: "#0B121E"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M169.007 148.311H151.912V125.844H165.851L169.007 128.999L169.007 148.311Z",
    fill: "#F7F7F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.673 136.383H154.991V137.492H163.673V136.383Z",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.673 134.184H154.991V135.293H163.673V134.184Z",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.673 131.984H154.991V133.093H163.673V131.984Z",
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M163.673 129.781H154.991V130.89H163.673V129.781Z",
    fill: "#D9D9D9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M156.689 10.7486C157.495 10.7486 158.148 10.0957 158.148 9.29031C158.148 8.48492 157.495 7.83203 156.689 7.83203C155.884 7.83203 155.231 8.48492 155.231 9.29031C155.231 10.0957 155.884 10.7486 156.689 10.7486Z",
    fill: "#FC1515"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M279.979 132.538C280.785 132.538 281.438 131.885 281.438 131.079C281.438 130.274 280.785 129.621 279.979 129.621C279.174 129.621 278.521 130.274 278.521 131.079C278.521 131.885 279.174 132.538 279.979 132.538Z",
    fill: "#FC1515"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.559 259.104C157.364 259.104 158.017 258.451 158.017 257.646C158.017 256.84 157.364 256.188 156.559 256.188C155.753 256.188 155.101 256.84 155.101 257.646C155.101 258.451 155.753 259.104 156.559 259.104Z",
    fill: "#FC1515"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2525 139.981H75.0049V138.5H76.2525V139.981Z",
    fill: "#343435"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1673 139.981H77.0483V138.5H78.1673V139.981ZM81.1512 139.981H78.9133V138.5H81.1512V139.981ZM83.0162 139.981H81.8972V138.5H83.0162V139.981Z",
    fill: "#343435"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1825 139.981H83.4141V138.5H86.1825V139.981ZM93.5649 139.981H88.0281V138.5H93.5649V139.981ZM100.947 139.981H95.4105V138.5H100.947V139.981ZM108.33 139.981H102.793V138.5H108.33V139.981ZM115.712 139.981H110.175V138.5H115.712V139.981ZM123.095 139.981H117.558V138.5H123.095V139.981ZM130.477 139.981H124.94V138.5H130.477V139.981ZM137.859 139.981H132.323V138.5H137.859V139.981ZM145.242 139.981H139.705V138.5H145.242V139.981ZM149.856 139.981H147.088V138.5H149.856V139.981Z",
    fill: "#343435"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.502 139.981H150.254V138.5H151.502V139.981Z",
    fill: "#343435"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M151.397 141.33C152.549 141.33 153.482 140.396 153.482 139.245C153.482 138.094 152.549 137.16 151.397 137.16C150.246 137.16 149.312 138.094 149.312 139.245C149.312 140.396 150.246 141.33 151.397 141.33Z",
    fill: "#343435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_848_194",
    x1: 284.314,
    y1: 138.131,
    x2: 35.4585,
    y2: 138.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04654,
    stopColor: "#C2D7F6",
    stopOpacity: 0.97011
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11611,
    stopColor: "#C7DBF7",
    stopOpacity: 0.88731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20009,
    stopColor: "#D0E0F8",
    stopOpacity: 0.75165
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29533,
    stopColor: "#DCE8FA",
    stopOpacity: 0.56298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40001,
    stopColor: "#EBF2FC",
    stopOpacity: 0.32113
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51106,
    stopColor: "#FDFEFF",
    stopOpacity: 0.03114
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52232,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_848_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293.333,
    height: 280,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHow);
export default __webpack_public_path__ + "static/media/TableHow.5f016007e8396fd227bc08f2099e5fc6.svg";
export { ForwardRef as ReactComponent };